<template>
  <div :class="minisizeMenu ? 'minisizeNav logout-div' : 'logout-div'">
    <a href="javascript:" class="logout" @click="fn_logout" title="Đăng xuất">
      <i class="isax-login mr-3" />
      <span v-if="!minisizeMenu">Đăng xuất</span>
    </a>
    <iframe class="d-none" :src="links" width="100%" frameborder="0"></iframe>
  </div>
</template>
<script>
import AuthService from "../service/AuthService";
import LanguageService from "../service/LanguageService";
import FirebaseApi from '../moduleApi/FirebaseApi';
import EventBus from "../service/EventBus";

export default {
  props: {
    minisizeMenu: {
      type: Boolean,
      default: false
    },
    isAnotherModuleAndMinisize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      links: ""
    }
  },
  methods: {
    fn_logout() {
      this.$confirm(LanguageService.lang.logout, {
        confirmButtonText: LanguageService.lang.c_yes,
        cancelButtonText: LanguageService.lang.c_no,
        type: "info"
      })
        .then(async () => {
          const firebaseToken = window.localStorage.getItem('currentToken');
          if (firebaseToken) {
            await FirebaseApi.deleteToken(firebaseToken);
            window.localStorage.removeItem('currentToken');
          }
          await EventBus.$emit("logout", {});
          await AuthService.logout("invalidClientSession") //Đăng xuất ở một thiết bị
            .then(res => {
              this.$message({
                showClose: true,
                message: "Đăng xuất thành công!",
                type: "success",
                duration: 8000, //8s
              });
              this.links +=
                window.MyConfig.timwookPath +
                "static/logout.html";
              setTimeout(() => {
                window.localStorage.clear();
                window.location.href = "/auth/login";
              }, 500);
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: "Đăng xuất thất bại!",
                type: "error"
              });
            });
        })
        .catch();
    },
  },
}
</script>
<style scoped>
.d-none {
  display: none;
}

.logout-div {
  color: var(--black);
  font-size: 16px;
  font-weight: 400;
  border-bottom: none;
  line-height: 23.23px;
  padding: 20px 30px 20px 25px;
}

.logout {
  color: var(--black);
  max-width: 150px;
  font-size: 15px;
}

.logout:hover {
  cursor: pointer;
  color: var(--black) !important;
  text-decoration: none;
}

.isax-login {
  width: 50px;
  float: left;
  margin: 0 20px 0 0;
  text-align: center;
}

.isax-login:before {
  font-size: 24px;
}

.minisizeNav .isax-login {
  text-align: left !important;
}
</style>
